import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const deleteSupportingDocument: (
  fetchContext: FetchContext,
  supportingDocumentId: number,
  accessToken?: string,
) => Promise<void> = (fetchContext, supportingDocumentId, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/supporting-documents/${supportingDocumentId}`,
  {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'delete supporting document'));
